import React from "react";

export function PageHeader({ kicker, title, subtitle, actions, testId }) {
  return (
    <div className="flex items-start justify-between gap-4 mb-6" data-testid={testId}>
      <div>
        {kicker && <div className="small-caps text-teal-700">{kicker}</div>}
        <h1 className="serif-display text-4xl text-slate-900 tracking-tight mt-1">{title}</h1>
        {subtitle && <p className="text-slate-500 text-[14px] mt-2 max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
}

export function Card({ children, className = "", title, subtitle, action }) {
  return (
    <div className={`surface p-5 ${className}`}>
      {(title || action) && (
        <div className="flex items-start justify-between mb-3">
          <div>
            {title && <h3 className="font-medium text-slate-900 text-[15px]">{title}</h3>}
            {subtitle && <p className="text-[12px] text-slate-500 mt-0.5">{subtitle}</p>}
          </div>
          {action}
        </div>
      )}
      {children}
    </div>
  );
}

export function KPI({ label, value, delta, deltaDir = "pos", suffix, testId }) {
  return (
    <div className="kpi-tile" data-testid={testId}>
      <div className="label">{label}</div>
      <div className="metric numerals">{value}{suffix && <span className="text-[16px] text-slate-400 ml-1 font-sans">{suffix}</span>}</div>
      {delta && (
        <div className={`text-[12px] mt-1 ${deltaDir === "neg" ? "delta-neg" : "delta-pos"}`}>
          {deltaDir === "neg" ? "▼" : "▲"} {delta}
        </div>
      )}
    </div>
  );
}

export function Tag({ tone = "slate", children, ...rest }) {
  return <span className={`tag tag-${tone}`} {...rest}>{children}</span>;
}

export function Empty({ text = "No data yet." }) {
  return <div className="text-center text-slate-400 text-[13px] py-8">{text}</div>;
}

export function fmt(n) {
  if (n == null) return "—";
  const num = typeof n === "number" ? n : Number(n);
  if (isNaN(num)) return n;
  return num.toLocaleString("en-IN");
}
